<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasBuyer="true"
      :hasFood="true"
      :hasFoodKind="true"
      :hasFoodStatusType="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["statistic", "warehouse", "order"],
      reportType: "statistic",
    };
  },
  computed: {
    columns() {
      if (this.reportType == "statistic") {
        return [
          { name: "FoodKindNumber" },
          { name: "FoodKindName" },
          { name: "FoodNumber" },
          { name: "FoodName" },
          { name: "Qty" },
          { name: "Unit" },
          { name: "Cost", headerText: "平均成本" },
          { name: "Total" },
        ];
      } else if (this.reportType == "warehouse") {
        return [
          { name: "FoodNumber" },
          { name: "FoodName" },
          { name: "WarehouseNumber" },
          { name: "WarehouseName" },
          { name: "Qty" },
          { name: "Unit" },
          { name: "Cost", headerText: "平均成本" },
          { name: "Total" },
        ];
      } else if (this.reportType == "order") {
        return [
          { name: "FoodNumber" },
          { name: "FoodName" },
          { name: "WarehouseNumber" },
          { name: "WarehouseName" },
          { name: "PurchaseOrderQty" },
          { name: "SaleOrderQty" },
          { name: "Unit" },
          { name: "Total" },
        ];
      } else {
        return undefined;
      }
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getFoodPurchaseOrder(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getFoodPurchaseOrder(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printFoodPurchaseOrder(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getFoodPurchaseOrder(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
